export const StageGroupType = {
  Content: "1",
};
